import React from 'react';
import classNames from 'classnames';
import ShareableLinkNavigation from './components/ShareableLinkNavigation';

import './ShareableLinkPage.styles.scss';

type ShareableLinkPageProps = {
  className?: string;
};

const ShareableLinkPage: React.FC<ShareableLinkPageProps> = (props) => {
  const { className, children } = props;

  const classes = classNames('shareable-link-page', className);

  return (
    <div className={classes}>
      <ShareableLinkNavigation />

      <div>
        <main>{children}</main>
      </div>
    </div>
  );
};

export default ShareableLinkPage;
